<template>
  <div class="head" v-if="Object.keys(kLineData).length !== 0">
    <!--    <van-icon name="arrow-left" color="#ffffff" @click="goBack" />-->
    <div class="metal">{{ kLineData.metalName }}</div>
    <!-- <img
      :src="require(`@/assets/share.png`)"
      alt=""
      @click="showShare = true"
    /> -->
    <div class="headContent">
      <div class="left">
        <div class="leftTop">
          <span>
            {{ price }}
            <img
              :src="
                kLineData.amount < 0
                  ? require(`@/assets/fall.png`)
                  : require(`@/assets/rise.png`)
              "
              alt=""
            />
          </span>
        </div>
        <div class="leftBottom">
          <div>{{ percentage + "%" }}</div>
          <div>{{ amount }}</div>
        </div>
      </div>
      <div class="right">
        <div class="rightTop">
          <div class="max">
            <div class="title">最高</div>
            <div class="val">{{ highPrice }}</div>
          </div>
          <div class="min">
            <div class="title">最低</div>
            <div class="val">{{ lowPrice }}</div>
          </div>
        </div>
        <div class="rightBottom">
          <div class="open">
            <div class="title">开盘</div>
            <div class="val">{{ openPrice }}</div>
          </div>
          <div class="yesterday">
            <div class="title">昨收</div>
            <div class="val">{{ closePrice }}</div>
          </div>
        </div>
      </div>
    </div>
    <!--    <van-share-sheet-->
    <!--      v-model="showShare"-->
    <!--      title="立即分享给好友"-->
    <!--      :options="options"-->
    <!--      @select="onSelect"-->
    <!--    />-->
  </div>
</template>

<script>
import { Toast } from "vant";

export default {
  props: ["kLineData", "showMask"],
  computed: {
    price() {
      return this.kLineData.price ? this.kLineData.price.toFixed(2) : "";
    },
    percentage() {
      return this.kLineData.percentage;
    },
    amount() {
      return this.kLineData.amount ? this.kLineData.amount.toFixed(2) : "";
    },
    highPrice() {
      return this.kLineData.highPrice
        ? this.kLineData.highPrice.toFixed(2)
        : "";
    },
    lowPrice() {
      return this.kLineData.lowPrice ? this.kLineData.lowPrice.toFixed(2) : "";
    },
    openPrice() {
      return this.kLineData.openPrice
        ? this.kLineData.openPrice.toFixed(2)
        : "";
    },
    closePrice() {
      return this.kLineData.closePrice
        ? this.kLineData.closePrice.toFixed(2)
        : "";
    },
  },
  data() {
    return {
      wechat: null,
      showShare: false,
      options: [
        { name: "微信", icon: "wechat" },
        { name: "复制链接", icon: "link" },
      ],
    };
  },
  created() {
    const ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      this.wechat = true;
    } else {
      this.wechat = false;
    }
  },
  mounted() {},

  methods: {
    onSelect(option) {
      if (option.name == "复制链接") {
        const url = window.location.href;
        this.$copyText(url).then(() => {
          Toast("已复制内容到剪切板");
        });
        this.showShare = false;
      } else if (option.name == "微信") {
        console.log("微信");
        console.log(this.showMask);
        this.showShare = false;
        this.$emit("update:showMask", true);
        console.log(this.showMask);
      }
    },
    goBack() {
      window.history.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .van-icon-arrow-left {
  top: 10px;
}

::v-deep .van-icon-arrow-left {
  position: absolute;
  top: 14px;
}
.head {
  width: 100vw;
  height: 273px;
  background-color: #e1ae58;
  padding-left: 24px;
  box-sizing: border-box;
  overflow: hidden;
  img {
    width: 25px;
    height: 25px;
    position: absolute;
    top: 24px;
    right: 40px;
  }
  .metal {
    width: 189px;
    height: 50px;
    color: rgba(255, 255, 255, 1);
    font-size: 36px;
    margin-top: 15px;
    margin-left: 40px;
  }
  .headContent {
    height: 136;
    width: 670px;
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    padding-left: 10px;
    .left {
      width: 176px;
      height: 108px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .leftTop {
        width: 197px;
        height: 67px;
        color: rgba(255, 255, 255, 1);
        font-size: 48px;
        line-height: 67px;
        span {
          position: relative;
          > img {
            width: 32px;
            image-rendering: pixelated; // 像素化，出现锯齿状，pass
            image-rendering: crisp-edges; // 无效
            object-fit: cover;
            position: absolute;
            top: 12px;
            right: -32px;
          }
        }
      }
      .leftBottom {
        display: flex;
        justify-content: space-between;
        color: rgba(255, 255, 255, 1);
        font-size: 24px;
      }
    }
    .right {
      width: 176px;
      height: 136px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .title {
        color: rgb(255, 255, 255);
        font-size: 22px;
      }
      .val {
        color: rgba(255, 255, 255, 1);
        font-size: 22px;
      }
      .rightTop {
        display: flex;
        justify-content: space-between;
      }
      .rightBottom {
        display: flex;
        justify-content: space-between;
      }
    }
  }
}
</style>
